var map = {
	"./angpao.webp": 2308,
	"./bonus.webp": 2309,
	"./gpi-rebate-m.webp": 2310,
	"./gpi-rebate.webp": 2311,
	"./hublot-watch-2018.webp": 2312,
	"./hublot-watch-2022.webp": 2313,
	"./iphone-13-pro-max.webp": 2314,
	"./iphone-14-pro-max.webp": 2315,
	"./login-to-m.webp": 2316,
	"./login-to.webp": 2317,
	"./mb.webp": 2318,
	"./mg-rebate-m.webp": 2319,
	"./mg-rebate.webp": 2320,
	"./np.webp": 2321,
	"./pointer.webp": 2322,
	"./pp-rebate-m.webp": 2323,
	"./pp-rebate.webp": 2324,
	"./sadface.webp": 2325,
	"./wallet-m.webp": 2326,
	"./wallet.webp": 2327,
	"./wheel-b.webp": 2328,
	"./wheel-btn.webp": 2329,
	"./wheel-indon-b.webp": 2330,
	"./wheel-indon.webp": 2331,
	"./wheel.webp": 2332
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 930;